import { Box, Stack } from "../../../includes";
import LazyLoading from "../../Wrappers/components/LazyLoading";
import DesktopWrapper from "../DesktopWrapper";
import MobileWrapper from "../MobileWrapper";
import { INoMenuWrapper } from "./types";

function NoMenuWrapper({ wrappedComponent }: INoMenuWrapper) {
  return (
    <>
      <DesktopWrapper>
        <Stack
          sx={{
            width: "100%",
            minHeight: "100vh",
            maxWidth: "100%",
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Stack
              sx={{
                width: "100vw",
                position: "relative",
                overflowX: "hidden",
                flex: 1,
                minHeight: "100vh",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  boxSizing: "border-box",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <LazyLoading component={wrappedComponent} />
              </Box>
            </Stack>
          </Box>
        </Stack>
      </DesktopWrapper>

      <MobileWrapper>
        <Stack
          sx={{
            position: "relative",
            minHeight: "100vh",
            overflowX: "hidden",
            padding: "8px 16px",
          }}
        >
          <Box
            sx={{
              padding: 0,
              margin: 0,
              maxWidth: "100%",
              overflowX: "hidden",
            }}
          >
            <LazyLoading component={wrappedComponent} />
          </Box>
        </Stack>
      </MobileWrapper>
    </>
  );
}

export default NoMenuWrapper;
